$(window).on('load', function () {

    //AUTOCOMPLETE PROMOCODES
    $("body").on("click", function(event){
        if (!$(event.target).hasClass('mg2-shop-autocomplete') && !$(event.target).hasClass('mg2-shop-linked-autocomplete')) {
            $(".mg2-shop-autocomplete").slideUp();
            $(".mg2-shop-autocomplete-edit").slideUp();
        }
    });

    $(".annAddPromoCode").on("click",annAddPromoCode);
    $(".annRemovePromoCode").on("click",annRemovePromoCode);

    $(".event_selection").change(function(event){
        event.preventDefault();
        var eventsChecked = $("input.event_selection:checkbox:checked");
        var eventIDs = "";
        for (var checkbox of eventsChecked) {
            eventIDs += checkbox.value + ',';
        }
        eventIDs = eventIDs.replace(/,\s*$/, "");
        $("#eventsList").val(eventIDs);
        console.log(eventIDs);
    });
    
    $(".event_selection_update").change(function(event){
        event.preventDefault();
        var update_id = $(this).attr("id");
        var eventsChecked = $("input.event_selection_update_"+update_id+":checkbox:checked");
        var eventIDs = "";
        for (var checkbox of eventsChecked) {
            eventIDs += checkbox.value + ',';
        }
        eventIDs = eventIDs.replace(/,\s*$/, "");
        $("#eventsListUpdate"+update_id).val(eventIDs);
        console.log(eventIDs);
    });
    
    // remove state to not always open on same box
    if ($('.mg2_detailed_options').length > 0) {
    	window.history.replaceState({}, '', $('.mg2_detailed_options').attr('data-url'));
    }

	const $pickers = $('.mg2_admin_color_item__picker');
	if ($pickers.length != 0) {
		enablePickers($pickers);
	}
    
    // INIT MULTIPLE SELECTIONS
    if ($(".mg2_multiple-inputs-ctn")[0]) {
        $("body").on("click", function(e) {
            var $targ = $(e.target);
            var $ctn = $targ.closest(".mg2_multiple-inputs-ctn");
           
            if ($ctn.length) {
                $ctn.addClass("open");
            } else {
                $(".mg2_multiple-inputs-ctn").removeClass("open");
            }
        });
        
        $(".mg2_multiple-inputs-select-item-input").on("change", function(e) {
            var $inp = $(e.currentTarget);
            var isChecked = e.currentTarget.checked;
            var $ctn = $inp.closest(".mg2_multiple-inputs-ctn");
            var $select = $ctn.find(".mg2_multiple-inputs-select-hook");
            var $option = $select.find("option");
            var values = $option.val().length === 0 ? [] : $option.val().indexOf(",") === -1 ? [$option.val()] : $option.val().split(',');
            var texts = $option.text().trim().length === 0 ? [] : $option.text().trim().indexOf("\u200b,") === -1 ? [$option.text().trim()] : $option.text().trim().split('\u200b, ');
            var optionText = $inp.closest('.mg2_multiple-inputs-select-item').text();
            var inputIndex = values.indexOf($inp.val());
            
            if (inputIndex === -1) {
                texts.push(optionText);
                values.push($inp.val());
            } else {
                texts.splice(inputIndex, 1);
                values.splice(inputIndex, 1);
            }

            $select.html('<option value="' + values.join() + '">' + texts.join('\u200b, ') + '</option>');
        });
    }
    
});

function annRemovePromoCode() {
    window.location.reload();
    return false;
}

var annAddPromoCode = function (event) {
    event.preventDefault();
    var sub_total = $('#payment-process-subtotal-price');
    var shippingFee = $('#payment-process-free-shipping');
    var promo_applied = $('#errorPromo');
    var fees_service = $("#fees-service");
    var fees_tps = $("#fees-tps");
    var fees_tvq = $("#fees-tvq");
    var commission = $("#commission-fee");
    var packageError = $("#packagePromoCodeError");
    var packageTotal = document.getElementById('packageTotal')!=null ? document.getElementById('packageTotal').value.trim() : 0;
    var packageTotal = 0; // Package is allowed for Promo codes fix
    console.log(fees_tvq);
    var net_total =$('#payment-process-step-1-amount-total-number');
    var net_total_2 = $('.mini-cart-total-amt');
    var promo = $("#promocodeId");   
    var promotionlabel = $("#promotionlabel");
    var inputTextPromoCode = $("#annPromoCode");
    var addPromoButton = $("#annAddPromoCode");
    var cancelPromo = $("#annRemovePromoCode");
    var code = encodeURIComponent(document.getElementById('annPromoCode').value.trim());
    var lang = document.getElementById('lang').value;
    var member_id = document.getElementById('member_id').value;
    var event_id = document.getElementById('event_id').value;
    if (code !== "") {
        ajax('/action/epPromoCode?code=' + code + '&member_id=' + member_id + "&event_id=" + event_id,
            function (response) {
                console.log(response);
                if (response=="notfound") {
                    if (lang == "fr") {
                        alert("Le code promotionnel n'est pas applicable!");
                    } else {
                        alert("Promo code is not applicable!");
                    }
                }

                if(packageError.length !== 0) {//packages available in the cart
                    if (lang == "fr") {
                        packageError.html("Le code promotionnel n'est pas applicable pour le forfait!");
                    }else{
                        packageError.html("Promo code is not applicable to packages!");
                    }
                    packageError.html(""); // Package is allowed for Promo codes fix
                }

                var responseArr = JSON.parse(response);
                if (responseArr != undefined && responseArr.length > 2) {

                    sub_total_value = sub_total.html().trim();
                    sub_total_value = sub_total_value.replace("$", "");
                    sub_total_value = sub_total_value.replace(",", ".");
			        sub_total_value = parseFloat(sub_total_value);

                    if(packageTotal!=0) {
                        packageTotal = packageTotal.replace("$", "");
                        packageTotal = packageTotal.replace(",", ".");
                    }
                    sub_total_value_for_promo = sub_total_value - packageTotal;

                    if(shippingFee.length !== 0)
                    {
                        shipping_fee = shippingFee.html().trim();
                        shipping_fee = shipping_fee.replace("$", "");
                        shipping_fee = shipping_fee.replace(",", ".");
                        shipping_fee = parseFloat(shipping_fee);
                    }else{
                        shipping_fee = 0;
                    }
                    
                    fees_service_value = fees_service.html().trim();
                    fees_service_value = fees_service_value.replace("$", "");
                    fees_service_value = fees_service_value.replace(",", ".");
			        fees_service_value = parseFloat(fees_service_value);

                    fees_tps_value = fees_tps.html().trim();
                    fees_tps_value = fees_tps_value.replace("$", "");
                    fees_tps_value = fees_tps_value.replace(",", ".");
			        fees_tps_value = parseFloat(fees_tps_value);

                    fees_tvq_value = fees_tvq.html().trim();
                    fees_tvq_value = fees_tvq_value.replace("$", "");
                    fees_tvq_value = fees_tvq_value.replace(",", ".");
			        fees_tvq_value = parseFloat(fees_tvq_value);

                    if(commission.length !== 0)
                    {
                        commission_value = commission.html().trim();
                        commission_value = commission_value.replace("$", "");
                        commission_value = commission_value.replace(",", ".");
                        commission_value = parseFloat(commission_value);
                    }else{
                        commission_value = 0;
                    }
                    
                    // console.log(sub_total_value);
                    // console.log(fees_service_value);
                    // console.log(fees_tps_value);
                    // console.log(fees_tvq_value);

                    promo_applied_value = promo_applied.html().trim();
                    net_total_value = net_total.html().trim();
                    if(responseArr[1]==1) {
                        promo_applied_value=(sub_total_value_for_promo - shipping_fee) *responseArr[2]/100;
                        promo_applied_value=promo_applied_value.toFixed(2);
                    } else {
                        if(sub_total_value_for_promo===0){
                            promo_applied_value = 0
                        }else {
                            promo_applied_value = responseArr[2];
                        }

                    }
                    net_total_value = sub_total_value-promo_applied_value;
                    if (net_total_value<0) { 
                        net_total_value=0; 
                    }
                    net_total_value = net_total_value+fees_service_value+fees_tps_value+fees_tvq_value+commission_value;
                    net_total_value=net_total_value.toFixed(2);

                    // console.log(promo_applied_value);
                    // console.log(net_total_value);

                    if (lang == "fr") {
                        promo_applied_value = promo_applied_value.toString().replace(".", ",");
                        net_total_value = net_total_value.toString().replace(".", ",");
                    }
                    promo_applied.html("-"+promo_applied_value+"$");
                    net_total.html(net_total_value+"$");
                    net_total_2.html(net_total_value+"$");
                    promo.val(responseArr[6]);
                    promotionlabel.show();
                    cancelPromo.show();
                    inputTextPromoCode.hide();
                    addPromoButton.hide();
                } else {
                    if (lang == "fr") {
                        alert("Le code promotionnel n'est pas applicable!");
                    } else {
                        alert("Promo code is not applicable!");
                    }
                }
            });
    } else {
        $(".errorPromo").show();
    }
}

/* Let's add a promo code*/
function catalogAddPromoCode() {
    var chosenLinked = [];
    var code = encodeURIComponent(document.getElementById('shoppccode').value.trim());
    var sel = document.getElementById('shoppctype');
    var type = sel.options[sel.selectedIndex].value;
    var value = encodeURIComponent(document.getElementById('shoppcvalue').value);
    var maxuse = encodeURIComponent(document.getElementById('shoppcmaxuse').value);
    var pId = (document.getElementById('shoppcpId') !== null) ? encodeURIComponent(document.getElementById('shoppcpId').value) : 0;
    var exp = encodeURIComponent(document.getElementById('shoppcExpire').value);
    var expdd = encodeURIComponent(document.getElementById('shoppcday').value);
    var expmm = encodeURIComponent(document.getElementById('shoppcmonth').value);
    var expyy = encodeURIComponent(document.getElementById('shoppcyear').value);
    var pIds = (document.getElementById('shoppcpIds') !== null) ? encodeURIComponent(chosenLinked.join(",")) : "";
    var eventsList = encodeURIComponent(document.getElementById('eventsList').value);
    var parent_category_id = encodeURIComponent(document.getElementById('parent_category_id').value);
    var profile_id = encodeURIComponent(document.getElementById('profile_id').value);
    var oneTimeUse = "";
    var shipping = "";
    if (code !== "") {
        ajax('/action/shopPromoCodesForMember?code=' + code + '&value=' + value + '&type=' + type
                + '&maxUse=' + maxuse + '&productId=' + pId + '&expirationDate=' + exp + '&expirationDateDay=' + expdd 
                + '&expirationDateMonth=' + expmm + '&expirationDateYear=' + expyy + shipping + oneTimeUse 
                + "&productIds=" + pIds + "&eventsList=" + eventsList + "&parentCategoryId=" + parent_category_id + "&profileId=" + profile_id,
                function (response) {
                    console.log(response);
                    window.location.href = "/promo?t=1";
                });
    } else {
        $("#shoppccode").addClass("mg2-missing-error");
    }
}

var oPcCode = "";
var oPcVal = "";
var oPcType = "";
var oPcExp = "";
var oPcMax = "";
var openedPcId = "";
var oPcShipping = "";
var oPcOneTimeUse = "";
var oPcLinked = "";
function catalogModifyPCOpen(id) {
    if ($('.button_' + id).hasClass('hidden_button')) {
        if (openedPcId != '') {
            cancelModifyPc(openedPcId);
        }
        openedPcId = id;
        oPcCode = $('#mg2_pc_code_' + id).attr('value');
        oPcVal = $('#mg2_pc_value_' + id).attr('value');
        oPcType = $('#mg2_pc_type_' + id).val();
        oPcShipping = $('#mg2_pc_shipping_' + id).is(":checked");
        oPcOneTimeUse = ($('#mg2_pc_oneTimeUse_' + id) !== null) ? $('#mg2_pc_oneTimeUse_' + id).is(":checked") : "";
        oPcExp = $('#mg2_pc_exp_' + id).attr('value');
        oPcMax = $('#mg2_pc_max_' + id).attr('value');
        $('#shop_pc_' + id + ' .mg2_invisible_input').addClass('mg2_visible_input');
        $('#shop_pc_' + id + ' .mg2_catalog_pc').removeAttr('disabled');
        $('#shop_pc_' + id + ' .mg2_catalog_pc').removeClass('mg2_disabled_input');
        $('#shop_pc_' + id + ' .mg2_invisible_input').removeClass('mg2_invisible_input');
        $('#shop_pc_' + id + ' .mg2_catalog_pc').addClass('mg2_enabled_input');
        $('#shop_pc_' + id + ' .mg2_catalog_linked').removeClass('mg2_disabled_input');
        $('#shop_pc_' + id + ' .mg2_catalog_linked').addClass('mg2_enabled_input');
        $('#shop_pc_' + id + ' .mg2_catalog_shipping').removeAttr('disabled');
        if ($('#shop_pc_' + id + ' .mg2_catalog_oneTimeUse').length !== 0) {
            $('#shop_pc_' + id + ' .mg2_catalog_oneTimeUse').removeAttr('disabled');
        }
        // SetCaretAtEnd(document.getElementById('mg2_pc_code_' + id));
        $('#shop_pc_' + id + ' .event_selection_select').show();
        $('#shop_pc_' + id + ' .event_selection_show').hide();
        $('.button_' + id).addClass('hidden_button');
        $('.button_' + id + '.mg2_check').removeClass('hidden_button');
        $('.button_' + id + '.mg2_cancel').removeClass('hidden_button');
    } else {
        cancelModifyPc(id);
    }
}

function catalogModifyPC(id) {
    var chosenLinked = [];
    var mod = "type=" + encodeURIComponent(document.getElementById('mg2_pc_type_' + id).value);
    mod += "&id=" + encodeURIComponent(id);
    mod += "&code=" + encodeURIComponent(document.getElementById('mg2_pc_code_' + id).value);
    mod += "&value=" + encodeURIComponent(document.getElementById('mg2_pc_value_' + id).value);
    mod += "&maxUse=" + encodeURIComponent(document.getElementById('mg2_pc_max_' + id).value);
    mod += "&expirationDateDay=" + encodeURIComponent(document.getElementById('shoppcday_' + id).value);
    mod += "&expirationDateMonth=" + encodeURIComponent(document.getElementById('shoppcmonth_' + id).value);
    mod += "&expirationDateYear=" + encodeURIComponent(document.getElementById('shoppcyear_' + id).value);  
    mod += "&productIds=" + encodeURIComponent(chosenLinked.join(","));
    mod += "&eventsList=" + encodeURIComponent(document.getElementById('eventsListUpdate' + id).value);
    mod += "&shipping=false";
    mod += "&oneTimeUse=false";
    ajax("/action/shopPromoCodesForMember?" + mod, function (response) {
        // catalogPcModified(response, id);
        console.log(response);
        window.location.href = "/promo?t=1";
    });
}
/* Once the option is modified, we close the modification display */
function catalogPcModified(response, id) {
    $('#shop_pc_' + id + ' .mg2-products-linked-names-tags').removeClass("new");
    cancelModifyPc(id, response);
}
function cancelModifyPc(id, response) {
    if (response == null || response == '') {
        $('#mg2_pc_code_' + id).val(oPcCode);
        $('#mg2_pc_value_' + id).val(oPcVal);
        $('#mg2_pc_type_' + id).val(oPcType);
        $('#mg2_pc_exp_' + id).val(oPcExp);
        $('#mg2_pc_max_' + id).val(oPcMax);
        $('#mg2_pc_linked_' + id).val(oPcLinked);
        if($('#mg2_pc_oneTimeUse_' + id) !== null){
            if (oPcOneTimeUse === true) {
                $('#mg2_pc_oneTimeUse_' + id).attr("checked", "true");
            } else {
                $('#mg2_pc_oneTimeUse_' + id).removeAttr("checked");
            }
        }
        if (oPcShipping === true) {
            $('#mg2_pc_shipping_' + id).attr("checked", "true");
        } else {
            $('#mg2_pc_shipping_' + id).removeAttr("checked");
        }
        $('#shop_pc_' + id + ' .mg2-products-linked-names-tags.new').remove();
        separateDateShop(document.getElementById('mg2_pc_exp_' + id), 'shoppcday_' + id, 'shoppcmonth_' + id, 'shoppcyear_' + id, document.getElementById('lang').value);
        
    }
    $('#shop_pc_' + id + ' .mg2_catalog_pc').attr('disabled', 'true');
    $('#shop_pc_' + id + ' .mg2_catalog_shipping').attr('disabled', 'true');
    if ($('#shop_pc_' + id + ' .mg2_catalog_shipping').length !== 0) {
        $('#shop_pc_' + id + ' .mg2_catalog_oneTimeUse').attr('disabled', 'true');
    }
    $('#shop_pc_' + id + ' .mg2_catalog_linked').attr('disabled', 'true');
    $('#shop_pc_' + id + ' .mg2_catalog_pc').removeClass('mg2_enabled_input');
    $('#shop_pc_' + id + ' .mg2_catalog_pc').addClass('mg2_disabled_input');
    $('#shop_pc_' + id + ' .mg2_visible_input').addClass('mg2_invisible_input');
    $('#shop_pc_' + id + ' .mg2_visible_input').removeClass('mg2_visible_input');
    $('#shop_pc_' + id + ' .event_selection_select').hide();
    $('#shop_pc_' + id + ' .event_selection_show').show();
    $('.button_' + id).addClass('hidden_button');
    $('.button_' + id + '.mg2_edit_icon').removeClass('hidden_button');
    openedPcId = "";
}

var confirm_box = false;
function shopDeletePromoCode(id) {
    if (id) {
        confirm_box = confirm("Are you sure to delete?");
        if (confirm_box) {
            ajax('/action/shopPromoCodesForMember?delete=true&id=' + id, function () {
                window.location.href = "/promo?t=1";
            });
        }
    } else {
        alert("Something went wrong!");
    }
}

function chooseDateShop(id, lang) {
    // if (lang == 'fr') {
    //     $(id).datepicker($.datepicker.regional[ "fr" ]);
    //     $(id).datepicker({});
    // } else {
    //     $(id).datepicker($.datepicker.regional[ "" ]);
    //     $(id).datepicker({});
    // }
    $(id).datepicker($.datepicker.regional[ "" ]);
    $(id).datepicker({});
    $(id).datepicker('show');
}
function chooseDateShopRange(id, lang, startId, endId) {
    $('#' + startId).datepicker(
            {
                numberOfMonths: 2,
                onSelect: function (selectedDate) {
                    $("#" + endId).datepicker("option", "minDate", selectedDate);
                    separateDateShop(selectedDate, 'startday', 'startmonth', 'startyear', lang);
                    separateDateShop(document.getElementById(endId), 'endday', 'endmonth', 'endyear', lang);
                }
            });
    $('#' + endId).datepicker(
            {
                numberOfMonths: 2,
                onSelect: function (selectedDate) {
                    $("#" + startId).datepicker("option", "maxDate", selectedDate);
                    separateDateShop(selectedDate, 'endday', 'endmonth', 'endyear', lang);
                    separateDateShop(document.getElementById(startId), 'startday', 'startmonth', 'startyear', lang);
                }
            });
	if (lang === 'en') {
		$(id).datepicker("option", "dateFormat", "mm/dd/yy");
	}
    $(id).datepicker('show');
}
function separateDateShop(elmt, dayValue, monthValue, yearValue, lang) {
    var date = "";
    if (typeof elmt === 'string') {
        date = elmt;
    } else {
        date = elmt.value;
    }
    var year;
    var month;
    var day;
    // if (lang == 'fr') {
    //     day = date.substring(0, date.indexOf("/"));
    //     month = date.substring(date.indexOf("/") + 1, date.indexOf("/", date.indexOf("/") + 1));
    //     year = date.substring(date.indexOf("/", date.indexOf("/") + 1) + 1);
    // } else {
    //     month = date.substring(0, date.indexOf("/"));
    //     day = date.substring(date.indexOf("/") + 1, date.indexOf("/", date.indexOf("/") + 1));
    //     year = date.substring(date.indexOf("/", date.indexOf("/") + 1) + 1);
    // }
    month = date.substring(0, date.indexOf("/"));
    day = date.substring(date.indexOf("/") + 1, date.indexOf("/", date.indexOf("/") + 1));
    year = date.substring(date.indexOf("/", date.indexOf("/") + 1) + 1);
    month = month - 1;
    if (month == -1) {
        month = 11;
    }
    if (day == '') {
        document.getElementById(dayValue).value = -1;
        document.getElementById(monthValue).value = -1;
        document.getElementById(yearValue).value = -1;
    } else {
        document.getElementById(dayValue).value = day;
        document.getElementById(monthValue).value = month;
        document.getElementById(yearValue).value = year;
    }
}
